import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/domain/item-page-data'

import { ItemPageUserInfoHeaderPluginModel } from './types'

export const getItemPageUserInfoHeaderPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageUserInfoHeaderPluginModel => ({
  feedbackReputation: itemDto.user.feedback_reputation,
  sellerId: itemDto.user.id,
  business: itemDto.user.business,
  businessAccount: itemDto.user.business_account,
  feedbackCount: itemDto.user.feedback_count,
  sellerLogin: itemDto.user.login,
  sellerPhoto: itemDto.user.photo,
  itemId: itemDto.id.toString(),
})

export const getServerItemPageUserInfoHeaderPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageUserInfoHeaderPluginModel => ({
  feedbackReputation: sidebarDto.feedback_reputation,
  sellerId: sidebarDto.seller_id,
  business: sidebarDto.business,
  businessAccount: sidebarDto.business_account,
  feedbackCount: sidebarDto.feedback_count,
  sellerLogin: sidebarDto.login,
  sellerPhoto: sidebarDto.seller_photo,
  itemId: sidebarDto.id.toString(),
})
